Alpine.store('inactiveRegistrations', {
    data: {},

    get(mainEventId){
        if (!mainEventId || ! Object.prototype.hasOwnProperty.call(this.data, mainEventId)) {
            return 0;
        }

        return this.data[mainEventId];
    },

    async syncData(url){
        const csrfToken = document.head
            .querySelector('[name="csrf-token"]')
            ?.getAttribute('content');

        const response = await fetch(url, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "X-Requested-With": "XMLHttpRequest",
                "X-CSRF-TOKEN": csrfToken,
            },
        });

        this.data = await response.json();
    },

    get total(){
        return Object.keys(this.data)
            .reduce((count, mainEventId) => count + this.data[mainEventId], 0);
    },
});
